import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import style from './Button.scss'

const BUTTON_SIZES = ['xl', 'md']

const BUTTON_THEMES = ['white', 'blueDark', 'greenDecide', 'submit']

function Button({
  children,
  size,
  xl,
  autoFocus,
  tabIndex,
  submit,
  href,
  target,
  onClick,
  disabled,
  className,
  loading,
  theme,
}) {
  let element = 'button'
  let type

  if (href) {
    element = 'a'
  }

  if (submit) {
    type = 'submit'
  }

  const classes = cx(style.button, {
    [style.xl]: xl || size === 'xl',
    [style.md]: !xl && size === 'md',
    [style[theme]]: theme,
    [style.disabled]: disabled,
    [style.loading]: loading,
    [className]: className,
  })

  return React.createElement(
    element,
    {
      type,
      className: classes,
      autoFocus,
      tabIndex,
      href,
      onClick,
      disabled,
      target: href && target,
    },
    children,
  )
}

Button.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
    .isRequired,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(BUTTON_SIZES),
  theme: PropTypes.oneOf(BUTTON_THEMES),
  className: PropTypes.string,
  target: PropTypes.string,
  xl: PropTypes.bool,
  autoFocus: PropTypes.bool,
  tabIndex: PropTypes.number,
  submit: PropTypes.bool,
  loading: PropTypes.bool,
  href: PropTypes.string,
  onClick: PropTypes.func,
}

Button.defaultProps = {
  size: 'md',
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Common/Button.js